"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcTemplateSelector = class UcTemplateSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getSelectedItemId(...args) {
        if (this.$route.params && this.$route.params.id) {
            return this.$route.params.id;
        }
    }
    onItemSelected(...args) {
        const [item] = args;
        this.$router.push({
            name: 'app.templates.template',
            params: { id: item.id }
        });
    }
    onItemCreated(...args) {
        console.log('onItemCreated', args);
    }
    cacheKey;
    onCache_key(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("cacheKey");
    }
    companyId;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("companyId");
    }
    variant;
    onVariant(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("variant");
    }
    toggleClass;
    onToggle_class(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("toggleClass");
    }
    messages;
    items;
    async $$load_items() {
        return this.$fn.fetch('list_template').then(d => _.sortBy(d, 'created_at'));
    }
    oid;
    async $$load_oid() {
        return this.getSelectedItemId();
    }
    selectedItem;
    async $$load_selectedItem() {
        return _.find(this.$data.items, { id: this.oid });
    }
    ux;
    dataMembers = ['messages', 'items', 'oid', 'selectedItem', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    noTemplateDefined: this.$fn.pgettext("TemplateSelector", "No template have been defined yet"),
                    selectTemplate: this.$fn.pgettext("TemplateSelector", "Select template"),
                    createTemplate: this.$fn.pgettext("TemplateSelector", "Create template..."),
                },
                items: null,
                oid: null,
                selectedItem: null,
                ux: null,
            },
        };
    }
    get noItemDefined() {
        if (this.loaded) {
            return !this.items.length;
        }
        return null;
    }
    get dropdownToggleClass() {
        if (this.loaded) {
            return 'border ' + (this.toggleClass || '');
        }
        return null;
    }
    async act_5962862420439144_setData_4890_getActionArgs($event) {
        return {
            path: "selectedItem",
            value: this.onItemSelected($event.scope.item),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_clickPrevent(event, scope) {
        return await this.actions.evh_5962862420439144_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_1048678296148443_script_4894_getActionArgs_value($event) {
        this.onItemCreated($event.data);
    }
    async act_1048678296148443_script_4894_getActionArgs($event) {
        return {
            value: () => this.act_1048678296148443_script_4894_getActionArgs_value($event),
        };
    }
    async evh_1048678296148443_close_4893_getWhen($event) {
        return $event.data.modalResult.value;
    }
    async act_1048678296148443_showModal_4892_getActionArgs($event) {
        return {
            name: "CreateTemplate",
        };
    }
    async evh_1048678296148443_clickPrevent(event, scope) {
        return await this.actions.evh_1048678296148443_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_setData_4890 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_4890_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_clickPrevent_4889 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_4890,
            event: "click.prevent",
            displayName: "setData",
        });
        const evh_5962862420439144_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_clickPrevent_4889],
        });
        const act_1048678296148443_script_4894 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1048678296148443_script_4894_getActionArgs,
            events: [],
        });
        const evh_1048678296148443_close_4893 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_script_4894,
            event: "close",
            when: this.evh_1048678296148443_close_4893_getWhen,
            displayName: "script",
        });
        const act_1048678296148443_showModal_4892 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1048678296148443_showModal_4892_getActionArgs,
            events: [evh_1048678296148443_close_4893],
        });
        const evh_1048678296148443_clickPrevent_4891 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_showModal_4892,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_1048678296148443_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_clickPrevent_4891],
        });
        return {
            act_5962862420439144_setData_4890,
            evh_5962862420439144_clickPrevent_4889,
            evh_5962862420439144_clickPrevent,
            act_1048678296148443_script_4894,
            evh_1048678296148443_close_4893,
            act_1048678296148443_showModal_4892,
            evh_1048678296148443_clickPrevent_4891,
            evh_1048678296148443_clickPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcTemplateSelector.prototype, "cacheKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('cacheKey'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplateSelector.prototype, "onCache_key", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcTemplateSelector.prototype, "companyId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplateSelector.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "light",
    }),
    __metadata("design:type", String)
], UcTemplateSelector.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplateSelector.prototype, "onVariant", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcTemplateSelector.prototype, "toggleClass", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('toggleClass'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcTemplateSelector.prototype, "onToggle_class", null);
UcTemplateSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcTemplateSelector);
exports.default = UcTemplateSelector;
vue_property_decorator_1.Vue.component("UcTemplateSelector", UcTemplateSelector);
